import styled from "@emotion/styled"

const ListTwoCardMobileText = styled.div`
  margin-top: 0;
  font-size: 18px;
  line-height: 29px;
  margin-bottom: 0;
  white-space: pre-wrap;
  font-weight: 500;

  p {
    margin: 0;
    opacity: 90%;
    text-align: left;
  }

  ${({ theme }) => theme.breakpoints.up("md")} {
    display: none;
  }
`

export default ListTwoCardMobileText
